var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favorite-gyms-viewer"},[_c('v-container',{attrs:{"fluid":""}},[_c('gym-viewer',{attrs:{"items":_vm.localValue,"no-items-text":"Нет избранных залов.","new-window":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }